import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { TextFormat, Translate, getSortState } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { ASC, DESC } from 'app/shared/util/pagination.constants';
import { overrideSortStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities } from './meter.reducer';

export const Meter = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [sortState, setSortState] = useState(
    overrideSortStateWithQueryParams(getSortState(pageLocation, 'id'), pageLocation.search),
  );

  const meterList = useAppSelector(state => state.meter.entities);
  const loading = useAppSelector(state => state.meter.loading);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        sort: `${sortState.sort},${sortState.order}`,
      }),
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?sort=${sortState.sort},${sortState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [sortState.order, sortState.sort]);

  const sort = p => () => {
    setSortState({
      ...sortState,
      order: sortState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = sortState.sort;
    const order = sortState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="meter-heading" data-cy="MeterHeading">
        <Translate contentKey="crawlerBackendApp.meter.home.title">Meters</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="crawlerBackendApp.meter.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/meter/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="crawlerBackendApp.meter.home.createLabel">Create new Meter</Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {meterList && meterList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="crawlerBackendApp.meter.id">ID</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('balanceSupplierCompanyId')}>
                  <Translate contentKey="crawlerBackendApp.meter.balanceSupplierCompanyId">
                    Balance Supplier Company Id
                  </Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('balanceSupplierCompanyId')} />
                </th>
                <th className="hand" onClick={sort('balanceResponsibleCompanyId')}>
                  <Translate contentKey="crawlerBackendApp.meter.balanceResponsibleCompanyId">
                    Balance Responsible Company Id
                  </Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('balanceResponsibleCompanyId')} />
                </th>
                <th className="hand" onClick={sort('meteringResponsibleCompanyId')}>
                  <Translate contentKey="crawlerBackendApp.meter.meteringResponsibleCompanyId">
                    Metering Responsible Company Id
                  </Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('meteringResponsibleCompanyId')} />
                </th>
                <th className="hand" onClick={sort('technicalCommunicationSM')}>
                  <Translate contentKey="crawlerBackendApp.meter.technicalCommunicationSM">
                    Technical Communication SM
                  </Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('technicalCommunicationSM')} />
                </th>
                <th className="hand" onClick={sort('allocationMethod')}>
                  <Translate contentKey="crawlerBackendApp.meter.allocationMethod">Allocation Method</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('allocationMethod')} />
                </th>
                <th className="hand" onClick={sort('contractedCapacity')}>
                  <Translate contentKey="crawlerBackendApp.meter.contractedCapacity">Contracted Capacity</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('contractedCapacity')} />
                </th>
                <th className="hand" onClick={sort('energyDeliveryStatus')}>
                  <Translate contentKey="crawlerBackendApp.meter.energyDeliveryStatus">
                    Energy Delivery Status
                  </Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('energyDeliveryStatus')} />
                </th>
                <th className="hand" onClick={sort('invoiceMonth')}>
                  <Translate contentKey="crawlerBackendApp.meter.invoiceMonth">Invoice Month</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('invoiceMonth')} />
                </th>
                <th className="hand" onClick={sort('maxConsumption')}>
                  <Translate contentKey="crawlerBackendApp.meter.maxConsumption">Max Consumption</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('maxConsumption')} />
                </th>
                <th className="hand" onClick={sort('physicalCapacity')}>
                  <Translate contentKey="crawlerBackendApp.meter.physicalCapacity">Physical Capacity</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('physicalCapacity')} />
                </th>
                <th className="hand" onClick={sort('isSmartMeterTurnedOn')}>
                  <Translate contentKey="crawlerBackendApp.meter.isSmartMeterTurnedOn">
                    Is Smart Meter Turned On
                  </Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('isSmartMeterTurnedOn')} />
                </th>
                <th className="hand" onClick={sort('standaardJaarAfname')}>
                  <Translate contentKey="crawlerBackendApp.meter.standaardJaarAfname">Standaard Jaar Afname</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('standaardJaarAfname')} />
                </th>
                <th className="hand" onClick={sort('standaardJaarInvoeding')}>
                  <Translate contentKey="crawlerBackendApp.meter.standaardJaarInvoeding">
                    Standaard Jaar Invoeding
                  </Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('standaardJaarInvoeding')} />
                </th>
                <th className="hand" onClick={sort('isSpecialMeteringPoint')}>
                  <Translate contentKey="crawlerBackendApp.meter.isSpecialMeteringPoint">
                    Is Special Metering Point
                  </Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('isSpecialMeteringPoint')} />
                </th>
                <th className="hand" onClick={sort('isDoubleMeter')}>
                  <Translate contentKey="crawlerBackendApp.meter.isDoubleMeter">Is Double Meter</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('isDoubleMeter')} />
                </th>
                <th className="hand" onClick={sort('transactionDossierNumber')}>
                  <Translate contentKey="crawlerBackendApp.meter.transactionDossierNumber">
                    Transaction Dossier Number
                  </Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('transactionDossierNumber')} />
                </th>
                <th className="hand" onClick={sort('reference')}>
                  <Translate contentKey="crawlerBackendApp.meter.reference">Reference</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('reference')} />
                </th>
                <th className="hand" onClick={sort('startDate')}>
                  <Translate contentKey="crawlerBackendApp.meter.startDate">Start Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('startDate')} />
                </th>
                <th className="hand" onClick={sort('endDate')}>
                  <Translate contentKey="crawlerBackendApp.meter.endDate">End Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('endDate')} />
                </th>
                <th className="hand" onClick={sort('productType')}>
                  <Translate contentKey="crawlerBackendApp.meter.productType">Product Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('productType')} />
                </th>
                <th className="hand" onClick={sort('meteringPeriod')}>
                  <Translate contentKey="crawlerBackendApp.meter.meteringPeriod">Metering Period</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('meteringPeriod')} />
                </th>
                <th className="hand" onClick={sort('feedType')}>
                  <Translate contentKey="crawlerBackendApp.meter.feedType">Feed Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('feedType')} />
                </th>
                <th className="hand" onClick={sort('profileCategory')}>
                  <Translate contentKey="crawlerBackendApp.meter.profileCategory">Profile Category</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('profileCategory')} />
                </th>
                <th className="hand" onClick={sort('capacityTariffCode')}>
                  <Translate contentKey="crawlerBackendApp.meter.capacityTariffCode">Capacity Tariff Code</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('capacityTariffCode')} />
                </th>
                <th className="hand" onClick={sort('physicalStatus')}>
                  <Translate contentKey="crawlerBackendApp.meter.physicalStatus">Physical Status</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('physicalStatus')} />
                </th>
                <th className="hand" onClick={sort('usageSegment')}>
                  <Translate contentKey="crawlerBackendApp.meter.usageSegment">Usage Segment</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('usageSegment')} />
                </th>
                <th className="hand" onClick={sort('locationDescription')}>
                  <Translate contentKey="crawlerBackendApp.meter.locationDescription">Location Description</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('locationDescription')} />
                </th>
                <th className="hand" onClick={sort('meterNumber')}>
                  <Translate contentKey="crawlerBackendApp.meter.meterNumber">Meter Number</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('meterNumber')} />
                </th>
                <th className="hand" onClick={sort('meterType')}>
                  <Translate contentKey="crawlerBackendApp.meter.meterType">Meter Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('meterType')} />
                </th>
                <th className="hand" onClick={sort('administrativeStatus')}>
                  <Translate contentKey="crawlerBackendApp.meter.administrativeStatus">Administrative Status</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('administrativeStatus')} />
                </th>
                <th className="hand" onClick={sort('smartMeterReadability')}>
                  <Translate contentKey="crawlerBackendApp.meter.smartMeterReadability">
                    Smart Meter Readability
                  </Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('smartMeterReadability')} />
                </th>
                <th className="hand" onClick={sort('temperatureCorrection')}>
                  <Translate contentKey="crawlerBackendApp.meter.temperatureCorrection">
                    Temperature Correction
                  </Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('temperatureCorrection')} />
                </th>
                <th className="hand" onClick={sort('numberOfCounters')}>
                  <Translate contentKey="crawlerBackendApp.meter.numberOfCounters">Number Of Counters</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('numberOfCounters')} />
                </th>
                <th className="hand" onClick={sort('counterIndication')}>
                  <Translate contentKey="crawlerBackendApp.meter.counterIndication">Counter Indication</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('counterIndication')} />
                </th>
                <th className="hand" onClick={sort('tariffZone')}>
                  <Translate contentKey="crawlerBackendApp.meter.tariffZone">Tariff Zone</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('tariffZone')} />
                </th>
                <th className="hand" onClick={sort('meteringDirection')}>
                  <Translate contentKey="crawlerBackendApp.meter.meteringDirection">Metering Direction</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('meteringDirection')} />
                </th>
                <th className="hand" onClick={sort('countingWheels')}>
                  <Translate contentKey="crawlerBackendApp.meter.countingWheels">Counting Wheels</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('countingWheels')} />
                </th>
                <th className="hand" onClick={sort('multiplicationFactor')}>
                  <Translate contentKey="crawlerBackendApp.meter.multiplicationFactor">Multiplication Factor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('multiplicationFactor')} />
                </th>
                <th className="hand" onClick={sort('initialStartDate')}>
                  <Translate contentKey="crawlerBackendApp.meter.initialStartDate">Initial Start Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('initialStartDate')} />
                </th>
                <th>
                  <Translate contentKey="crawlerBackendApp.meter.meterAddress">Meter Address</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="crawlerBackendApp.meter.ean">Ean</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {meterList.map((meter, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/meter/${meter.id}`} color="link" size="sm">
                      {meter.id}
                    </Button>
                  </td>
                  <td>{meter.balanceSupplierCompanyId}</td>
                  <td>{meter.balanceResponsibleCompanyId}</td>
                  <td>{meter.meteringResponsibleCompanyId}</td>
                  <td>{meter.technicalCommunicationSM}</td>
                  <td>{meter.allocationMethod}</td>
                  <td>{meter.contractedCapacity}</td>
                  <td>{meter.energyDeliveryStatus}</td>
                  <td>{meter.invoiceMonth}</td>
                  <td>{meter.maxConsumption}</td>
                  <td>{meter.physicalCapacity}</td>
                  <td>{meter.isSmartMeterTurnedOn ? 'true' : 'false'}</td>
                  <td>{meter.standaardJaarAfname}</td>
                  <td>{meter.standaardJaarInvoeding}</td>
                  <td>{meter.isSpecialMeteringPoint ? 'true' : 'false'}</td>
                  <td>{meter.isDoubleMeter ? 'true' : 'false'}</td>
                  <td>{meter.transactionDossierNumber}</td>
                  <td>{meter.reference}</td>
                  <td>
                    {meter.startDate ? (
                      <TextFormat type="date" value={meter.startDate} format={APP_LOCAL_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>
                    {meter.endDate ? (
                      <TextFormat type="date" value={meter.endDate} format={APP_LOCAL_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>
                    <Translate contentKey={`crawlerBackendApp.ProductType.${meter.productType}`} />
                  </td>
                  <td>
                    <Translate contentKey={`crawlerBackendApp.MeteringPeriod.${meter.meteringPeriod}`} />
                  </td>
                  <td>
                    <Translate contentKey={`crawlerBackendApp.FeedType.${meter.feedType}`} />
                  </td>
                  <td>{meter.profileCategory}</td>
                  <td>{meter.capacityTariffCode}</td>
                  <td>{meter.physicalStatus}</td>
                  <td>{meter.usageSegment}</td>
                  <td>{meter.locationDescription}</td>
                  <td>{meter.meterNumber}</td>
                  <td>{meter.meterType}</td>
                  <td>{meter.administrativeStatus}</td>
                  <td>{meter.smartMeterReadability}</td>
                  <td>{meter.temperatureCorrection}</td>
                  <td>{meter.numberOfCounters}</td>
                  <td>{meter.counterIndication}</td>
                  <td>{meter.tariffZone}</td>
                  <td>{meter.meteringDirection}</td>
                  <td>{meter.countingWheels}</td>
                  <td>{meter.multiplicationFactor}</td>
                  <td>
                    {meter.initialStartDate ? (
                      <TextFormat type="date" value={meter.initialStartDate} format={APP_LOCAL_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>
                    {meter.meterAddress ? (
                      <Link to={`/address/${meter.meterAddress.id}`}>{meter.meterAddress.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>{meter.ean ? <Link to={`/ean/${meter.ean.id}`}>{meter.ean.id}</Link> : ''}</td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`/meter/${meter.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/meter/${meter.id}/edit`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() => (window.location.href = `/meter/${meter.id}/delete`)}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="crawlerBackendApp.meter.home.notFound">No Meters found</Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default Meter;
